// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header_wrapper__r1\\+ms {
  align-items: baseline;
  gap: 24px;
}
.Header_userRow__FY\\+d5,
.Header_notificationBtn__9GaHR,
.Header_pill__xf6W0 {
  display: flex;
  align-items: center;
}
.Header_wrapper__r1\\+ms,
.Header_bellColumn__uLD4v {
  display: flex;
  flex-direction: column;
}
.Header_topRow__\\+nXda {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
}
.Header_title__x3ga3 {
  font-size: 40px;
  line-height: 48px;
  text-align: left;
  color: #4d4d4d;
}
.Header_title__x3ga3,
.Header_pill__xf6W0 {
  font-family: Inter;
  font-weight: 600;
  letter-spacing: -0.001em;
}
.Header_userRow__FY\\+d5 {
  gap: 48px;
  width: 30%;
}
.Header_userRow__FY\\+d5,
.Header_notificationBtn__9GaHR,
.Header_wrapper__r1\\+ms,
.Header_pill__xf6W0 {
  justify-content: center;
}
.Header_searchIcon__3ZCeC {
  height: 24px;
  margin: 10px 16px 0px;
  position: absolute;
  width: 24px;
}

.Header_searchInput__jMSRD {
  border: 1px solid #d9dce0;
  width: 438px;
  height: 46px;
  padding: 8px 16px 8px 46px;
  border-radius: 8px;
}
.Header_searchInput__jMSRD::placeholder {
  color: rgba(95, 109, 126, 0.6);
  font-family: Inter;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: -0.001em;
}
.Header_searchInput__jMSRD:focus {
  border: 1px solid rgba(203, 156, 45, 1);
  outline: none;
}
.Header_notificationBtn__9GaHR {
  width: 40px;
  height: 40px;
  box-shadow: 3px 4px 16px 0px #7e818c1f;
  border: 1px solid #e2e2e2;
  background-color: white;
  border-radius: 5px;
  transition: background-color 300ms;
}
.Header_notificationBtn__9GaHR:hover {
  background-color: #e2e2e2;
  cursor: pointer;
}
.Header_bell__Ig\\+rN {
  width: 24px;
  height: 24px;
}
.Header_bellColumn__uLD4v {
  align-items: flex-end;
  justify-content: flex-start;
  position: relative;
}
.Header_pill__xf6W0 {
  width: 16px;
  height: 16px;
  border-radius: 31px;
  background-color: #cb2d2d;
  font-size: 10px;
  line-height: 12px;
  text-align: left;
  color: #ffffff;
  position: absolute;
  top: -4px;
  right: -1.5px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Header/Header.module.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,SAAS;AACX;AACA;;;EAGE,aAAa;EACb,mBAAmB;AACrB;AACA;;EAEE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,WAAW;AACb;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;;;;EAIE,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,uCAAuC;EACvC,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,kCAAkC;AACpC;AACA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,aAAa;AACf","sourcesContent":[".wrapper {\n  align-items: baseline;\n  gap: 24px;\n}\n.userRow,\n.notificationBtn,\n.pill {\n  display: flex;\n  align-items: center;\n}\n.wrapper,\n.bellColumn {\n  display: flex;\n  flex-direction: column;\n}\n.topRow {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  width: 100%;\n}\n.title {\n  font-size: 40px;\n  line-height: 48px;\n  text-align: left;\n  color: #4d4d4d;\n}\n.title,\n.pill {\n  font-family: Inter;\n  font-weight: 600;\n  letter-spacing: -0.001em;\n}\n.userRow {\n  gap: 48px;\n  width: 30%;\n}\n.userRow,\n.notificationBtn,\n.wrapper,\n.pill {\n  justify-content: center;\n}\n.searchIcon {\n  height: 24px;\n  margin: 10px 16px 0px;\n  position: absolute;\n  width: 24px;\n}\n\n.searchInput {\n  border: 1px solid #d9dce0;\n  width: 438px;\n  height: 46px;\n  padding: 8px 16px 8px 46px;\n  border-radius: 8px;\n}\n.searchInput::placeholder {\n  color: rgba(95, 109, 126, 0.6);\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n}\n.searchInput:focus {\n  border: 1px solid rgba(203, 156, 45, 1);\n  outline: none;\n}\n.notificationBtn {\n  width: 40px;\n  height: 40px;\n  box-shadow: 3px 4px 16px 0px #7e818c1f;\n  border: 1px solid #e2e2e2;\n  background-color: white;\n  border-radius: 5px;\n  transition: background-color 300ms;\n}\n.notificationBtn:hover {\n  background-color: #e2e2e2;\n  cursor: pointer;\n}\n.bell {\n  width: 24px;\n  height: 24px;\n}\n.bellColumn {\n  align-items: flex-end;\n  justify-content: flex-start;\n  position: relative;\n}\n.pill {\n  width: 16px;\n  height: 16px;\n  border-radius: 31px;\n  background-color: #cb2d2d;\n  font-size: 10px;\n  line-height: 12px;\n  text-align: left;\n  color: #ffffff;\n  position: absolute;\n  top: -4px;\n  right: -1.5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Header_wrapper__r1+ms`,
	"userRow": `Header_userRow__FY+d5`,
	"notificationBtn": `Header_notificationBtn__9GaHR`,
	"pill": `Header_pill__xf6W0`,
	"bellColumn": `Header_bellColumn__uLD4v`,
	"topRow": `Header_topRow__+nXda`,
	"title": `Header_title__x3ga3`,
	"searchIcon": `Header_searchIcon__3ZCeC`,
	"searchInput": `Header_searchInput__jMSRD`,
	"bell": `Header_bell__Ig+rN`
};
export default ___CSS_LOADER_EXPORT___;
